import { Component, OnDestroy, OnInit } from "@angular/core";
import { DataService_RoomSetup } from "./shared/data.service";
import { DialogService } from "primeng/dynamicdialog";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import { ConfirmationService } from "primeng/api";
import { AddRoomComponent } from "./add-room/add-room.component";
import { EditRoomComponent } from "./edit-room/edit-room.component";

@Component({
	selector: "app-room-setup",
	templateUrl: "./room-setup.component.html",
	styleUrls: ["./room-setup.component.css"],
})
export class RoomSetupComponent implements OnInit, OnDestroy {
	constructor(
		private selectService: SchoolselectorService,
		private dataService: DataService_RoomSetup,
		private confirmationService: ConfirmationService,
		private dialogService: DialogService
	) {}

	ngOnInit(): void {
		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			this.onSchoolChange(school);
		});
	}

	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	subscription: any;
	SelectedSchool: any;

	pagerows: number = 10;
	pagefirst: number = 0;

	lstTable: any = [];
	SelectedRoom: any;
	//Filter lists
	lstIsImportedDesc: any = [];
	lstActiveDesc: any = [];

	//Cols
	cols: any = [
		{ field: "RoomNo", header: "Room Number" },
		{ field: "RoomDesc", header: "Description" },
		// { field: "IsImportedDesc", header: "Imported" },
		// { field: "ActiveDesc", header: "Active" },
		// { field: "c_dateDesc", header: "Last Updated" },
	];

	ToggleText: string = "Deactivate Room";

	TableLoading: boolean = false;
	Processing: boolean = false;
	errorMessage: any = "";

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////

	loadTable() {
		if (this.SelectedSchool == undefined || this.SelectedSchool.SchoolID == undefined) {
			return;
		}

		this.onRowUnselect(null);

		this.TableLoading = true;

		var result = this.dataService.RoomSelectList(this.SelectedSchool.SchoolID);
		result.subscribe(
			(response) => {
				this.lstTable = response;

				this.lstIsImportedDesc = Array.from(new Set(this.lstTable.map((item: any) => item.IsImportedDesc)));
				this.lstActiveDesc = Array.from(new Set(this.lstTable.map((item: any) => item.ActiveDesc)));

				this.TableLoading = false;
			},
			(error) => {
				this.TableLoading = false;
			}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////

	onRefresh() {
		this.loadTable();
	}

	onAdd() {
		this.errorMessage = "";

		var ref = this.dialogService.open(AddRoomComponent, {
			header: "Add Room",
			width: "fit-content",
			data: {
				SelectedSchool: this.SelectedSchool,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadTable();
			}
		});
	}

	onEdit() {
		this.errorMessage = "";

		if (this.SelectedRoom == undefined || this.SelectedRoom.RoomID == undefined) {
			this.errorMessage = "Select a room to edit";
			return;
		}

		var ref = this.dialogService.open(EditRoomComponent, {
			header: "Edit Room",
			width: "fit-content",
			data: {
				SelectedSchool: this.SelectedSchool,
				SelectedRoom: this.SelectedRoom,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadTable();
			}
		});
	}

	onToggle() {
		this.errorMessage = "";

		if (this.SelectedRoom == undefined || this.SelectedRoom.RoomID == undefined) {
			this.errorMessage = "Select a room to deactivate";
			return;
		}
		if (this.SelectedRoom.IsImported == true) {
			this.errorMessage = "Cannot deactivate an imported Room";
			return;
		}

		this.Processing = true;

		var ChangeTo = this.SelectedRoom.Active == true ? 0 : 1;

		var result = this.dataService.RoomToggle(this.SelectedRoom.RoomID, ChangeTo);
		result.subscribe(
			(response: any) => {
				if (response.Status == true) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "room",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Room was " + (ChangeTo == 1 ? "Activated" : "Deactivated") + " Successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.loadTable();
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "room",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not " + (ChangeTo == 1 ? "Activate" : "Deactivate") + " the Room: " + response,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}

				this.Processing = false;
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	onDelete() {
		this.errorMessage = "";

		if (this.SelectedRoom == undefined || this.SelectedRoom.RoomID == undefined) {
			this.errorMessage = "Select a room to delete";
			return;
		}
		if (this.SelectedRoom.IsImported == true) {
			this.errorMessage = "Cannot delete an imported Room";
			return;
		}

		this.confirmationService.confirm({
			key: "roomconfirm",
			acceptLabel: "Yes",
			rejectLabel: "No",
			rejectVisible: true,
			message: "Are you sure you want to delete room: " + this.SelectedRoom.RoomNo + "?",
			header: "Confirm Delete",
			icon: "fa",
			accept: () => {
				this.onFinishDelete();
			},
		});
	}

	onFinishDelete() {
		this.Processing = true;

		var result = this.dataService.RoomDelete(this.SelectedRoom.RoomID);
		result.subscribe(
			(response: any) => {
				if (response.Status == true) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "room",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Room was Deleted Successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.loadTable();
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "room",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not Delete the Room: " + response,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}

				this.Processing = false;
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////

	onSchoolChange(val) {
		this.SelectedSchool = val;

		this.loadTable();
	}

	onRowSelect(val) {
		this.errorMessage = "";
		this.SelectedRoom = val.data;

		this.ToggleText = "Deactivate Room";
		if (this.SelectedRoom.Active == false) {
			this.ToggleText = "Activate Room";
		}
	}

	onRowUnselect(val) {
		this.errorMessage = "";
		this.SelectedRoom = null;

		this.ToggleText = "Deactivate Room";
	}

	onRowDblClick(Room) {
		this.SelectedRoom = Room;

		this.ToggleText = "Deactivate Room";
		if (this.SelectedRoom.Active == false) {
			this.ToggleText = "Activate Room";
		}

		this.onEdit();
	}
	////////////////////////////////////////////

	////////////////////////////////////////////
	// Helpers
	////////////////////////////////////////////
	IsLoading() {
		return this.TableLoading == true || this.Processing == true;
	}
	////////////////////////////////////////////
}
